import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PUBLISHERS_FILE_CONFIGURATION_TOKEN } from './tokens';

@NgModule({
  imports: [CommonModule]
})
export class SharedUtilLoggingModule {
  static forRoot(
    publishers_file_path: string = `/assets/log-publishers.json`
  ): ModuleWithProviders<{}> {
    return {
      ngModule: SharedUtilLoggingModule,
      providers: [
        {
          provide: PUBLISHERS_FILE_CONFIGURATION_TOKEN,
          useValue: publishers_file_path
        }
      ]
    };
  }
}
